/**
 * Configuration centralisée pour l'administration
 * Toutes les règles de pagination, formats, validations en un seul endroit
 */

export const ADMIN_CONFIG = {
  adminBaseUrl :'/administration/management',
  // Pagination par défaut
  pagination: {
    defaultPage: 0,
    defaultSize: 10,
    pageSizeOptions: [5, 10, 20, 50, 100],
  },

  // Formats de dates
  dateFormats: {
    display: 'dd/MM/yyyy',
    displayWithTime: 'dd/MM/yyyy HH:mm',
    api: 'yyyy-MM-dd',
  },

  // Validations communes
  validation: {
    minNameLength: 2,
    maxNameLength: 100,
    minDescriptionLength: 10,
    maxDescriptionLength: 1000,
    minPrice: 0,
    maxPrice: 1000000,
    minStock: 0,
    maxStock: 10000,
    maxFileSize: 5 * 1024 * 1024, // 5MB
    allowedImageTypes: ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'],
  },

  // Messages d'erreur par défaut
  errorMessages: {
    required: 'Ce champ est obligatoire',
    minLength: (min: number) => `Minimum ${min} caractères requis`,
    maxLength: (max: number) => `Maximum ${max} caractères autorisés`,
    email: 'Format email invalide',
    min: (min: number) => `La valeur minimale est ${min}`,
    max: (max: number) => `La valeur maximale est ${max}`,
    pattern: 'Format invalide',
    invalidFileType: 'Type de fichier non autorisé',
    fileTooLarge: 'Fichier trop volumineux',
  },

  // Durées des toasts
  toast: {
    successDuration: 3000,
    errorDuration: 5000,
    warningDuration: 4000,
  },

  // Délais de debounce
  debounce: {
    search: 300,
    autoSave: 1000,
  },

  // Statuts
  orderStatuses: [
    {value: 'PENDING', label: 'En attente', color: 'warning'},
    {value: 'CONFIRMED', label: 'Confirmée', color: 'info'},
    {value: 'PREPARING', label: 'En préparation', color: 'info'},
    {value: 'SHIPPED', label: 'Expédiée', color: 'primary'},
    {value: 'DELIVERED', label: 'Livrée', color: 'success'},
    {value: 'COMPLETED', label: 'Complétée', color: 'success'},
    {value: 'RETURNED', label: 'Retournée', color: 'danger'},
    {value: 'CANCELLED', label: 'Annulée', color: 'danger'},
  ],

  complaintStatuses: [
    {value: 'NEW', label: 'Nouvelle', color: 'info'},
    {value: 'PENDING', label: 'En attente', color: 'warning'},
    {value: 'RESOLVED', label: 'Résolue', color: 'success'},
  ],

  productStatuses: [
    {value: 'DRAFT', label: 'Brouillon', color: 'secondary'},
    {value: 'PUBLISHED', label: 'Publié', color: 'success'},
    {value: 'SCHEDULED', label: 'Planifié', color: 'info'},
  ],

} as const;
